import { ScreenTracking, SCREEN_ASSET_ID } from '../../../domain/amplitude'
import { PROCESSING_SCREEN } from '../ApplicationSubmitted/types'

export type OfferDeclinedComponentProps = {
  handleDone: () => void
}

export const OfferDeclinedScreenOpened: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: 'Offer declined',
  screen: 'offerDeclined',
  from_screen: PROCESSING_SCREEN
}
